export default {
  title: 'Common Area Fees',
  new_fee: 'New Fee',
  edit_fee: 'Edit Fee',
  description: 'Manage maintenance fund, sinking fund, insurance and other common area fees',

  labels: {
    name: 'Fee Name',
    fee_type: 'Fee Type',
    calculation_method: 'Calculation Method',
    rate: 'Rate (฿)',
    vat_rate: 'VAT Rate (%)',
    effective_from: 'Effective From',
    effective_until: 'Effective Until',
    description: 'Description',
    status: 'Status',
    total_amount: 'Total Amount',
    unit_number: 'Unit',
    area_sqm: 'Area (sqm)',
    share_ratio: 'Share Ratio',
    calculated_amount: 'Amount (฿)',
  },

  placeholders: {
    name: 'e.g., Annual Maintenance Fund',
    rate: '0.00',
    vat_rate: '7',
    description: 'Optional description',
  },

  fee_types: {
    maintenance_fund: 'Maintenance Fund',
    sinking_fund: 'Sinking Fund',
    insurance: 'Insurance',
    other: 'Other',
  },

  calculation_methods: {
    per_unit: 'Per Unit (flat rate)',
    per_sqm: 'Per Square Meter',
    per_share_ratio: 'Per Share Ratio',
    fixed_amount: 'Fixed Amount (total)',
  },

  status: {
    active: 'Active',
    expired: 'Expired',
    upcoming: 'Upcoming',
  },

  actions: {
    add_fee: 'Add Fee',
    preview: 'Preview Breakdown',
    hide_preview: 'Hide Preview',
  },

  preview: {
    title: 'Per-Unit Breakdown Preview',
    description: 'Based on current unit data and the fee settings above',
    loading: 'Calculating breakdown...',
    empty: 'No units found for this property',
    total: 'Total',
    // EP-54: split into i18next v25 plural forms; base key removed.
    units_count_one: '{{count}} unit',
    units_count_other: '{{count}} units',
  },

  messages: {
    created: 'Common area fee created successfully',
    updated: 'Common area fee updated successfully',
    deleted: 'Common area fee deleted successfully',
    delete_confirm: 'Delete fee "{{name}}"?',
    no_fees: 'No common area fees configured',
    no_fees_description: 'Add fees such as maintenance fund, sinking fund, or insurance.',
    condominium_only: 'Common area fees are only available for condominium properties.',
    share_ratio_warning: 'Share ratios do not sum to 1.0. Total: {{total}}',
    missing_sqm_warning: 'Some units are missing area (sqm) data.',
    missing_ratio_warning: 'Some units are missing share ratio data.',
  },

  validation: {
    name_required: 'Fee name is required',
    fee_type_required: 'Fee type is required',
    calculation_method_required: 'Calculation method is required',
    rate_required: 'Rate is required',
    rate_positive: 'Rate must be positive',
    effective_from_required: 'Effective from date is required',
    vat_rate_range: 'VAT rate must be between 0 and 100',
  },

  // EP-111 T111-8 — the CAF sidebar page ("meter-reading style"): pick a
  // condominium property, view the active rate + history, and supersede it
  // via "Set new rate". The structure (fee type / calculation method) stays
  // read-only here — it's configured on the property's CAF tab.
  rates_page: {
    title: 'Common Area Fees',
    description: 'View the active rate, per-unit breakdown, and rate history for each condominium property.',
    property_label: 'Property',
    set_new_rate: 'Set new rate',
    save_rate: 'Save rate',
    new_effective_from: 'New effective from',
    set_rate_success: 'New rate set successfully',
    superseding_context: 'Setting a new rate for "{{name}}" ({{method}}). The current rate closes automatically the day before the new one takes effect.',
    method_context: '{{fee_type}} · {{method}} · VAT {{vat}}%',
    open: 'Open',
    closed: 'Closed',
    effective_since: 'Effective since {{date}}',
    no_active_rate: 'No active rate. This fee series has no open row.',
    per_unit_breakdown: 'Per-unit breakdown',
    rate_history: 'Rate history',
    no_condo_properties_title: 'No condominium properties yet',
    no_condo_properties_description: 'Mark a property as condominium on its Overview tab to manage its common area fee rate here.',
    no_fees_configured_title: 'No common area fee configured',
    no_fees_configured_description: 'Add a fee type and calculation method on this property\'s Common Area Fees tab first, then manage its rate here.',
    configure_on_caf_tab: 'Configure Common Area Fees',
    zero_area_warning: 'No area set, will be skipped',
    zero_ratio_warning: 'No share ratio set, will be skipped',
  },
}
